import { useIsUngated } from 'automation-ui-core/hooks/authHooks';
import * as SourceApps from 'automation-ui-source-apps/constants/SourceApps';
import { useFlpAccess } from 'automation-ui-permissions/flp/hooks/useFlpAccess';
import Gates from 'automation-ui-management/constants/Gates';
import { ASSIGN_TEAM } from 'automation-ui-permissions/feature-permissions/constants/WorkflowManagementFeatures';
import FlpRestrictedPropertiesMessage from 'automation-ui-management/components/flp/FlpRestrictedPropertiesMessage';
import { BusinessUnitsRebrandMessage } from 'ui-business-units-lib/components/BusinessUnitsRebrandMessage';
import UIButton from 'UIComponents/button/UIButton';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import { jsx as _jsx } from "react/jsx-runtime";
const ALLOWED_BUSINESS_UNIT_SOURCE_APPS = new Set([SourceApps.DIRECT_API, SourceApps.PUBLIC_API, SourceApps.WORKFLOWS_APP, SourceApps.WORKFLOWS_CLASSIC]);
const OpenBusinessUnitModalButton = ({
  flowId,
  onClick,
  sourceApp,
  hasCurrentBusinessUnit,
  children,
  tooltipPlacement
}) => {
  const {
    loading: loadingFlpAccess,
    data: flpAccessData,
    error: flpAccessError
  } = useFlpAccess(flowId);
  const isUngatedForBusinessUnitAllSourceApps = useIsUngated(Gates.BUSINESS_UNITS_ALL_SOURCE_APPS);
  const hasFlpAccess = !loadingFlpAccess && !flpAccessError && (flpAccessData === null || flpAccessData === void 0 ? void 0 : flpAccessData.hasAccess(ASSIGN_TEAM));
  let isAccessDisabled = !ALLOWED_BUSINESS_UNIT_SOURCE_APPS.has(sourceApp) || !hasFlpAccess;
  if (isUngatedForBusinessUnitAllSourceApps && hasFlpAccess) {
    isAccessDisabled = false;
  }

  // TODO: this component is rendered inside UIDropdown's which doesn't have
  // styles "in menu" styles targeted at foundations components so they end
  // up center aligned. maintaining usage of UIButtons until foundations
  // Dropdown component is ready for prime time and menus and buttons can be
  // migrated at the same time.
  const buttonContent = /*#__PURE__*/_jsx(UIButton, {
    onClick: onClick,
    disabled: isAccessDisabled,
    children: children || (hasCurrentBusinessUnit ? /*#__PURE__*/_jsx(BusinessUnitsRebrandMessage, {
      message: "automation-ui-management.OpenBusinessUnitModalButton.changeBU.label",
      rebrandMessage: "automation-ui-management.OpenBusinessUnitModalButton.changeBU.label_buv2"
    }) : /*#__PURE__*/_jsx(BusinessUnitsRebrandMessage, {
      message: "automation-ui-management.OpenBusinessUnitModalButton.assignBU.label",
      rebrandMessage: "automation-ui-management.OpenBusinessUnitModalButton.assignBU.label_buv2"
    }))
  });
  if (isAccessDisabled) {
    return /*#__PURE__*/_jsx(UITooltip, {
      placement: tooltipPlacement || 'right',
      title: !hasFlpAccess ? /*#__PURE__*/_jsx(FlpRestrictedPropertiesMessage, {
        label: /*#__PURE__*/_jsx(BusinessUnitsRebrandMessage, {
          message: "automation-ui-management.button.accessDisabled.assignBusinessUnitFlp",
          rebrandMessage: "automation-ui-management.button.accessDisabled.assignBusinessUnitFlp_buv2"
        }),
        flpRejectionReasons: flpAccessData.flpRejectionReasons
      }) : hasCurrentBusinessUnit ? /*#__PURE__*/_jsx(BusinessUnitsRebrandMessage, {
        message: "automation-ui-management.OpenBusinessUnitModalButton.changeBU.disabled",
        rebrandMessage: "automation-ui-management.OpenBusinessUnitModalButton.changeBU.disabled_buv2"
      }) : /*#__PURE__*/_jsx(BusinessUnitsRebrandMessage, {
        message: "automation-ui-management.OpenBusinessUnitModalButton.assignBU.disabled",
        rebrandMessage: "automation-ui-management.OpenBusinessUnitModalButton.assignBU.disabled_buv2"
      }),
      children: buttonContent
    });
  } else {
    return buttonContent;
  }
};
export default OpenBusinessUnitModalButton;